export const ADD_DIE = "ADD_DIE"
export const REMOVE_DIE = "REMOVE_DIE"
export const DIE_TYPES = {
  D4: "D4",
  D6: "D6",
  D8: "D8",
  D10: "D10",
  D12: "D12",
  D20: "D20",
  D100: "D100",
}
export const DICE_REDUCER = "DICE_REDUCER"
export const UPDATE_DICE_COLOR = "UPDATE_DICE_COLOR"
export const SET_DICE = "SET_DICE"
export const UPDATE_DICE_COUNTS = "UPDATE_DICE_COUNTS"
export const HANDLE_SWITCH_MODE = "HANDLE_SWITCH_MODE"
// export const SAVE_MULTI_MODE_STATE = "SAVE_MULTI_MODE_STATE"
// export const RESTORE_MULTI_MODE_STATE = "RESTORE_MULTI_MODE_STATE"
